<template>
  <!-- pagination -->
  <div>
    <el-pagination
      background
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="pageform.currentPage"
      :page-sizes="pageSizeArr || [10, 20, 40]"
      :page-size="pageform.pageSize"
      layout="total, sizes, prev, pager, next,jumper"
      :total="pageform.totalCount"
      class="pagination_position"
    ></el-pagination>
  </div>
</template>
<script>
export default {
  props: {
    pageSizeArr: {
      type: Array,
    },
  },
  data() {
    return {
      // 页码
      pageform: {
        totalCount: 0,
        pageSize: 10,
        currentPage: 1,
      },
    };
  },
  methods: {
    getData(obj) {
      if (obj == "default") {
        this.pageform.pageSize = 10;
        this.pageform.totalCount = 0;
        this.pageform.currentPage = 1;
      } else {
        this.pageform.totalCount = obj.totalCount;
        this.pageform.pageSize = obj.pageSize;
        this.pageform.currentPage = obj.currPage;
      }
    },
    // 分页数量
    handleSizeChange(val) {
      this.pageform.pageSize = val;
      this.handleCurrentChange(1);
    },
    // 页码
    handleCurrentChange(val) {
      this.pageform.currentPage = val;
      this.$emit("getPage", this.pageform);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/video/components/page.vue